import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import moment from 'moment';

import './styles.scss';

export default function NextCriticalDate({ deal }) {
  if (!deal.nextCriticalDate.date) return null;

  const { date, label } = deal.nextCriticalDate;
  const criticalDate = moment(date);
  const differentYear = criticalDate.year() !== moment().year();

  return (
    <div className="next-critical-date">
      <div className={classNames('date', { 'date-with-year': differentYear })}>
        {differentYear && <div className="critical-date-year">{criticalDate.format('YYYY')}</div>}
        <div className="critical-date-month">{criticalDate.format('MMM').toUpperCase()}</div>
        <div className="critical-date-day">{criticalDate.format('D')}</div>
      </div>
      <div className="critical-date-name">
        <a href={deal.path + '/planner'}>{label}</a>
      </div>
    </div>
  );
}

NextCriticalDate.propTypes = {
  deal: PropTypes.shape({
    nextCriticalDate: PropTypes.object.isRequired,
  }).isRequired,
};
